export const eur = (n) => (n == null ? "—" : `${Number(n).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`);
export const isPanel = (t) => (t || "").toLowerCase().includes("modul");
export const perWp = (v, p) => {
  const val = Number(v), wp = Number(p?.kwp || 0) * 1000;
  if (!isPanel(p?.tipologia) || !val || val <= 0 || !wp) return null;
  return `${(val / wp).toLocaleString("it-IT", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} €/Wp`;
};
export const pct = (v) => (v ? `-${String(v).replace(".", ",")}%` : "0%");
